/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "काल्हिक दिन",
        "0": "आजुक दिन",
        "1": "काल्हिक दिन",
        "future": {
          "other": "{0} दिन मे"
        },
        "past": {
          "other": "{0} दिन मे"
        }
      },
      "day-narrow": {
        "-1": "बीतल काल्हि",
        "0": "आजुक दिन",
        "1": "आबय वला काल्हि",
        "future": {
          "other": "{0} दिन मे"
        },
        "past": {
          "other": "{0}दिन पहिले"
        }
      },
      "day-short": {
        "-1": "बीतल काल्हि",
        "0": "आजुक दिन",
        "1": "आबय वला काल्हि",
        "future": {
          "other": "{0} दिन मे"
        },
        "past": {
          "other": "{0}दिन पहिले"
        }
      },
      "hour": {
        "0": "एहि घंटा",
        "future": {
          "other": "{0} घंटा मे"
        },
        "past": {
          "other": "{0} घंटा पहिले"
        }
      },
      "hour-narrow": {
        "0": "एहि घंटा",
        "future": {
          "other": "{0} घंटा मे"
        },
        "past": {
          "other": "{0} घंटा पहिले"
        }
      },
      "hour-short": {
        "0": "एहि घंटा",
        "future": {
          "other": "{0} घंटा मे"
        },
        "past": {
          "other": "{0} घंटा पहिले"
        }
      },
      "minute": {
        "0": "एहि मिनट",
        "future": {
          "other": "{0} मिनट मे"
        },
        "past": {
          "other": "{0} मिनट पहिले"
        }
      },
      "minute-narrow": {
        "0": "एहि मिनट",
        "future": {
          "other": "{0} मिनट मे"
        },
        "past": {
          "other": "{0} मिनट पहिले"
        }
      },
      "minute-short": {
        "0": "एहि मिनट",
        "future": {
          "other": "{0} मिनट मे"
        },
        "past": {
          "other": "{0} मिनट पहिले"
        }
      },
      "month": {
        "-1": "बीतल माह",
        "0": "एहि माह",
        "1": "अगिला माह",
        "future": {
          "other": "{0} माह मे"
        },
        "past": {
          "other": "{0} माह पहिले"
        }
      },
      "month-narrow": {
        "-1": "बीतल माह",
        "0": "एहि माह",
        "1": "अगिला माह",
        "future": {
          "other": "{0}माह मे"
        },
        "past": {
          "other": "{0}माह पहिले"
        }
      },
      "month-short": {
        "-1": "बीतल माह",
        "0": "एहि माह",
        "1": "अगिला माह",
        "future": {
          "other": "{0} माह मे"
        },
        "past": {
          "other": "{0} माह पहिले"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "बीतल तिमाही",
        "0": "एहि तिमाही",
        "1": "अगिला तिमाही",
        "future": {
          "other": "{0} तिमाही मे"
        },
        "past": {
          "other": "{0} तिमाही पहिले"
        }
      },
      "quarter-narrow": {
        "-1": "बीतल तिमाही",
        "0": "एहि तिमाही",
        "1": "अगिला तिमाही",
        "future": {
          "other": "{0} तिमाही मे"
        },
        "past": {
          "other": "{0} तिमाही पहिले"
        }
      },
      "quarter-short": {
        "-1": "बीतल तिमाही",
        "0": "एहि तिमाही",
        "1": "अगिला तिमाही",
        "future": {
          "other": "{0} तिमाही मे"
        },
        "past": {
          "other": "{0} तिमाही पहिले"
        }
      },
      "second": {
        "0": "एहि समय",
        "future": {
          "other": "{0} सेकेंड मे"
        },
        "past": {
          "other": "{0} सेकेंड पहिले"
        }
      },
      "second-narrow": {
        "0": "एहि समय",
        "future": {
          "other": "{0} सेकेंड मे"
        },
        "past": {
          "other": "{0} सेकेंड पहिले"
        }
      },
      "second-short": {
        "0": "एहि समय",
        "future": {
          "other": "{0} सेकेंड मे"
        },
        "past": {
          "other": "{0} सेकेंड पहिले"
        }
      },
      "week": {
        "-1": "बीतल सप्ताह",
        "0": "एहि सप्ताह",
        "1": "अगिला सप्ताह",
        "future": {
          "other": "{0} सप्ताह मे"
        },
        "past": {
          "other": "{0} सप्ताह पहिले"
        }
      },
      "week-narrow": {
        "-1": "बीतल सप्ताह",
        "0": "एहि सप्ताह",
        "1": "अगिला सप्ताह",
        "future": {
          "other": "{0} सप्ताह मे"
        },
        "past": {
          "other": "{0} सप्ताह पहिले"
        }
      },
      "week-short": {
        "-1": "बीतल सप्ताह",
        "0": "एहि सप्ताह",
        "1": "अगिला सप्ताह",
        "future": {
          "other": "{0} सप्ताह मे"
        },
        "past": {
          "other": "{0} सप्ताह पहिले"
        }
      },
      "year": {
        "-1": "बीतल बरख",
        "0": "एहि बरख",
        "1": "अगिला बरख",
        "future": {
          "other": "{0} बरख मे"
        },
        "past": {
          "other": "{0} बरख पहिले"
        }
      },
      "year-narrow": {
        "-1": "बीतल बरख",
        "0": "एहि बरख",
        "1": "अगिला बरख",
        "future": {
          "other": "{0}बरख मे"
        },
        "past": {
          "other": "{0}बरख पहिले"
        }
      },
      "year-short": {
        "-1": "बीतल बरख",
        "0": "एहि बरख",
        "1": "अगिला बरख",
        "future": {
          "other": "{0} बरख मे"
        },
        "past": {
          "other": "{0} बरख पहिले"
        }
      }
    },
    "locale": "mai"
  });
}